<style type="text/css" media="screen" >
.request-box{
	width: 145px;
	border: 2px solid #6D7C8E;
	box-sizing: border-box;
	border-radius: 20px;	
}

.return-box{
	border: 2px solid #6D7C8E;
	box-sizing: border-box;
	border-radius: 20px;
	width:175px;
}
.balance-box{
	border: 2px solid #1DC895;
	box-sizing: border-box;
	border-radius: 20px;
	/* width: 230px; */
}
.initiate-withdrawal-btn{
	position: absolute;
	top: 90px;
	right:30px;
}

@media only screen and (max-width: 600px) {
	.s-margin-top{
		padding-top: 40px;
	}
}

</style>
<template>
	<div>
		<div class="initiate-withdrawal-btn text-right">
			<span class="secodry-text-4 mr-3 ">{{$lang.INITIATE_WITHDRAWAL.toUpperCase()}}</span>
			<v-btn color="primary" fab small depressed @click="$router.push({name:'initiate-withdrawal'})">	
				<v-icon>mdi-plus</v-icon>
			</v-btn>
		</div>
		<div class="s-margin-top">
			<!-- return card -->
			<div class="d-inline-block request-box pa-4 cursor-pointer">
				<p class="secodry-text-2 fs-14">{{$lang.REQUESTS}}</p>
				<p class="secodry-text-2 fw-800 fs-36">{{withdrawal_request_count}}</p>
			</div>	
			<!-- return card -->
			<!--  withdraw card -->
			<div class="d-inline-block balance-box pa-4 mx-5" >
				<div class="d-inline-block cursor-pointer">
					<p class="secodry-text-2  fs-14">{{$lang.CURRENT_BALANCE}}</p>
					<img src="../../../assets/rupee.svg" alt="" width="20">
					<span class="sub-title-text fs-36">
						{{current_balance}}
					</span>
				</div>
			</div>
			<div class="d-inline-block return-box pa-4 cursor-pointer">
				<p class="secodry-text-2 fs-14">{{$lang.TOTAL_RETURNS}}</p>
				<p class="secodry-text-2 fw-800 fs-36">{{return_count}}</p>
			</div>
		</div>


	</div>
</template>
<script>
export default{
	props:['current_balance','return_count','withdrawal_request_count'],
	methods:{
		gotoReturnsList(){
			if (this.return_count>0)
				this.$router.push({name:'returns',query:{type:this.encript(this.$keys.RETURNS)}})
		},
		gotoCollectionList(){
			if (this.current_balance>0)
				this.$router.push({name:'collections',query:{type:this.encript(this.$keys.COLLECTION)}})
		},
		withdraw(){
			if(this.return_count>0||  this.current_balance>0)
				this.$router.push({name:'confirm-withdrawal'})
			else
				this.$store.dispatch('snackbar/setSnackbar', {flag:true, text:"Nothing to withdraw", color:"warning" })
		}
	}
}	
</script>